import { lazy, Suspense, useContext } from "react";
import { Route, Routes } from "react-router-dom";
// import "./App.css";
import AuthContext from "./component/auth-context";
// import ChequeService from "./pages/ChequeServicePage/ChequeService";
import Commission from "./component/Commissionpage/Commission";
import ChequeServiceState from "./component/contextfolder/ChequeServiceContext/ChequeServiceState";
import CommissionState from "./component/contextfolder/CommissionContext/CommissionState";
import CooperativeState from "./component/contextfolder/Cooperativecontext/CooperativeState";
import CreditManagementState from "./component/contextfolder/CreditManagementContext/CreditManagementState";
import InternalFundState from "./component/contextfolder/InternalFundContext/InternalFundState";
import LoadWalletState from "./component/contextfolder/LoadWalletContext/LoadWalletState";
import NotificationState from "./component/contextfolder/NotificationContext/NotificationState";
import RemittanceState from "./component/contextfolder/RemittanceContext/RemittanceState";
import ReportState from "./component/contextfolder/ReportContext/ReportState";
import RequestState from "./component/contextfolder/RequestSendContext/RequestState";
import SliderState from "./component/contextfolder/SliderContext/SliderState";
import UserState from "./component/contextfolder/UserContext/UserState";
import Cooperative from "./component/Cooperativepage/Cooperative";
// import CreditManagement from "./pages/CreditManagementPage/CreditManagement";
import Dashboard from "./pages/DashboardPage/Dashboard";
import InternalFund from "./pages/Transaction/InternalFundPage/InternalFund";
import LandingPage from "./pages/LandingPage/LandingPage";

import Layout from "./component/Layout";
import Login from "./component/Login";
import PrivacyPolicy from "./component/PrivacyPolicy";
import SidebarState from "./component/sidebarcontext/SidebarState";
import { createTheme, CssBaseline, ThemeProvider } from "@mui/material";
import { ToastContainer, Zoom } from "react-toastify";
import Spinner from "./custom/Spinner";
import { baseThemeOptions, denseComponentStyles } from "./theme/Theme";

// Pages Components
const User = lazy(() => import("./pages/UserPage/User"));
const TransactionTab = lazy(() => import("./pages/Transaction/TransactionTab"));
const Summary = lazy(() => import("./pages/Transaction/Summary"));
const ChequeService = lazy(() => import("./pages/ChequeServicePage/ChequeService"));
const Request = lazy(() => import("./pages/RequestPage/Request"));
const CreditManagement = lazy(() => import("./pages/CreditManagementPage/CreditManagement"));
const Notification = lazy(() => import("./pages/NotificationPage/Notification"));
const Slider = lazy(() => import("./pages/Sliderpage/Slider"));

function App() {
  const auth = localStorage.getItem("userInfo");
  const authCtx = useContext(AuthContext);

  const theme = createTheme({
    ...baseThemeOptions,
    components: {
      ...denseComponentStyles,
    },
  });

  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <Suspense fallback={<Spinner />}>
        <ToastContainer
          position="top-center"
          autoClose={3000}
          limit={3}
          hideProgressBar={false}
          newestOnTop
          closeOnClick
          rtl={false}
          pauseOnFocusLoss
          draggable
          pauseOnHover
          theme="light"
          transition={Zoom}
        />
        <>
          <Routes>
            <Route path="/" element={<LandingPage />} />
            <Route path="/login" element={<Login />} />
            {/* <Route path="/" element={<Login />} /> */}
            <Route path="/privacy-policy/:name" element={<PrivacyPolicy />} />
            <Route path="/privacy-policy" element={<PrivacyPolicy />} />
            {/* <Route path="*" element={<Login />} /> */}
            {!auth && <Route path="/login" element={<Login />} />}
          </Routes>

          {authCtx.isLoggedIn && (
            <SidebarState>
              <UserState>
                <CreditManagementState>
                  <NotificationState>
                    <SliderState>
                      <RequestState>
                        <ChequeServiceState>
                          <LoadWalletState>
                            <RemittanceState>
                              <InternalFundState>
                                <ReportState>
                                  <CooperativeState>
                                    <CommissionState>
                                      <Layout>
                                        <Routes>
                                          <Route path="/dashboard" element={<Dashboard />} />
                                          <Route path="/user" element={<User />} />
                                          <Route path="/report" element={<TransactionTab />} />
                                          <Route path="/summary" element={<Summary />} />
                                          <Route path="/cheque-service" element={<ChequeService />} />
                                          <Route path="/request" element={<Request />} />
                                          <Route path="/credit-management" element={<CreditManagement />} />
                                          <Route path="/notification" element={<Notification />} />
                                          <Route path="/slider" element={<Slider />} />

                                          <Route path="/commission" element={<Commission />} />
                                          <Route path="/cooperative" element={<Cooperative />} />
                                          <Route path="/internal" element={<InternalFund />} />
                                          <Route path="/privacy-policy/:name" element={<PrivacyPolicy />} />
                                        </Routes>
                                      </Layout>
                                    </CommissionState>
                                  </CooperativeState>
                                </ReportState>
                              </InternalFundState>
                            </RemittanceState>
                          </LoadWalletState>
                        </ChequeServiceState>
                      </RequestState>
                    </SliderState>
                  </NotificationState>
                </CreditManagementState>
              </UserState>
            </SidebarState>
          )}
        </>
      </Suspense>
    </ThemeProvider>
  );
}

export default App;
